"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9013],{

/***/ 7749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 10,
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.53.47A.75.75 0 0 0 .47 1.53L1.53.47ZM5 5l.53.53a.75.75 0 0 0 0-1.06L5 5ZM.47 8.47a.75.75 0 0 0 1.06 1.06L.47 8.47Zm0-6.94 4 4 1.06-1.06-4-4L.47 1.53Zm4 2.94-4 4 1.06 1.06 4-4-1.06-1.06Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgAngleRight);

/***/ }),

/***/ 9013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ BreadCrumbs; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(917);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1463);
/* harmony import */ var _styled_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6196);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);
/* harmony import */ var _public_img_angle_right_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7749);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5944);



var _excluded = ["items", "currentCity"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var _ref2 =  true ? {
  name: "1fzjorl",
  styles: "width:5px"
} : 0;

var _ref3 =  true ? {
  name: "1bbh8tn",
  styles: "color:#7D7B7A"
} : 0;

var _ref4 =  true ? {
  name: "1fzjorl",
  styles: "width:5px"
} : 0;

function BreadCrumbs(_ref) {
  var items = _ref.items,
      currentCity = _ref.currentCity,
      restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList",
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_objectSpread((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
      display: 'flex',
      gap: 16,
      fontsize: 14,
      fontFamily: 'Golos',
      fontWeight: 400,
      a: {
        color: theme.colors.text,
        borderBottom: "1px solid ".concat(theme.colors.text)
      },
      textWrap: 'nowrap'
    }, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, {
      display: 'none'
    }), restProps),  true ? "" : 0,  true ? "" : 0),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
        itemProp: "item",
        href: ['', currentCity.url, ''].join('/'),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
          itemProp: "name",
          children: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("meta", {
        itemProp: "position",
        content: "0"
      })]
    }), items.map(function (item, index) {
      if (index + 1 === items.length) {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_public_img_angle_right_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              css: _ref2
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
            itemProp: "itemListElement",
            itemScope: true,
            itemType: "https://schema.org/ListItem",
            css: _ref3,
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
              itemProp: "name",
              children: item.title
            }), ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("meta", {
              itemProp: "position",
              content: "".concat(index + 1)
            })]
          })]
        });
      }

      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_public_img_angle_right_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            css: _ref4
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
          itemProp: "itemListElement",
          itemScope: true,
          itemType: "https://schema.org/ListItem",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
            itemProp: "item",
            href: item.href || ['', currentCity.url, item.url, ''].join('/'),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
              itemProp: "name",
              children: item.title
            })
          }), ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("meta", {
            itemProp: "position",
            content: "".concat(index + 1)
          })]
        })]
      });
    })]
  });
}

/***/ })

}]);